<template>
    <adam v-if="user" variant="hub" :company="user.company_id.toString()"></adam>
</template>

<script>
    import Adam from '@/components/Adam'

    export default {
        components: {
            Adam
        },
        computed: {
            user() {
                return this.$store.getters.getUser;
            }
        }
    }
</script>